// App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import HomePage from "./pages/home";
import AboutPage from "./pages/about";
import Header from "./layouts/header";
import Footer from "./layouts/footer";
import NotFoundPage from "./pages/404";
import ContactUsPage from "./pages/contact-us";
import OurCourse from "./pages/our-course";
import SubCourse from "./pages/sub-course";
import EnquiryFormPage from "./pages/enqiryPage";
import DonatePage from "./pages/donatePage";
import ScrollToTop from "./common-components/ScrollToTop";
import CarrierPage from "./pages/carrier-form";
import BioPage from "./pages/bioPage";
import WhatsappButton from "./common-components/WhatsappButton";
import ReactGA from "react-ga4";

const TRACKING_ID = "G-75M03ESWLW";
ReactGA.initialize(TRACKING_ID);
function GAListener({ children }) {
  const location = useLocation();

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return children;
}
class App extends React.Component {
  
  render() {
    const dynamicHeaderData = {
      phone: {
        en: "+91 9057203762",
        ur: "+۹۱ ۹۰۵۷۲۰۳۷۶۲",
        ro: "+91 9057203762",
      },
      email: {
        en: "info@learnquraneasily.in",
        ur: "info@learnquraneasily.in",
        ro: "info@learnquraneasily.in",
      },
      brandName: {
        en: "Learn Quran Easily",
        ur: "لرن قرآن ایزلی",
        ro: "Learn Quran Easily",
      },
      brandHighlight: {
        en: "QuranEasily",
        ur: "قرآن آسانی سے",
        ro: "Quran Asani Se",
      },
      navLinks: [
        {
          label: {
            en: "Home",
            ur: "ہوم",
            ro: "Home",
          },
          to: "/",
        },
        {
          label: {
            en: "About Us",
            ur: "ہمارے بارے میں",
            ro: "About Us",
          },
          to: "/about",
        },
        {
          label: {
            en: "Our Course",
            ur: "ہمارے کورسز",
            ro: "Our Course",
          },
          to: "/our-course",
        },
        {
          label: {
            en: "Registration",
            ur: "رجسٹریشن",
            ro: "Registration",
          },
          to: "/student-registration",
        },
        {
          label: {
            en: "Career Form",
            ur: "کیریئر فارم",
            ro: "Career Form",
          },
          to: "/career-form",
        },
        {
          label: {
            en: "Our Leaders",
            ur: "ہمارے اساتذہ",
            ro: "Our Leaders",
          },
          to: "/our-leaders",
        },
        {
          label: {
            en: "Contact",
            ur: "رابطہ کریں",
            ro: "Contact",
          },
          to: "/contact",
        },
      ],
    };

    return (
      <Router>
      <GAListener />
        <div>
          <ScrollToTop />
          <WhatsappButton />
          <Header {...dynamicHeaderData} /> {/* Render Header here */}
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/our-course" element={<OurCourse />} />
            <Route path="/our-course/:id" element={<SubCourse />} />
            <Route path="/student-registration" element={<EnquiryFormPage />} />
            <Route path="/career-form" element={<CarrierPage />} />
            <Route path="/donate" element={<DonatePage />} />
            <Route path="/our-leaders" element={<BioPage />} />
            {/* <Route path="/blog" element={<BlogPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/activity" element={<ActivityPage />} />
            <Route path="/event" element={<EventPage />} />
            <Route path="/sermon" element={<SermonsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/testimonial" element={<TestimonialPage />} /> */}
            {/* Add the TestimonialPage route */}
            <Route path="/contact" element={<ContactUsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    );
  }
}

export default App;
